import { useSyncExternalStore } from 'react';
import { isAuthenticated, getUserRole, getUserName } from '../services/api';

/**
 * Единый реактивный источник состояния авторизации.
 *
 * Подписывается на глобальное событие `auth-change` (логин/логаут/401 в этой
 * вкладке) и на `storage` (изменения в других вкладках). Любой компонент,
 * читающий useAuth(), перерисовывается сразу при смене состояния — поэтому
 * охранники маршрутов и хедер обновляются мгновенно, без ручных подписок.
 */
const subscribe = (callback) => {
  window.addEventListener('auth-change', callback);
  window.addEventListener('storage', callback);
  return () => {
    window.removeEventListener('auth-change', callback);
    window.removeEventListener('storage', callback);
  };
};

// Снимок — строка-примитив, чтобы Object.is сравнивал по значению
// (одинаковое содержимое → нет лишней перерисовки, нет цикла).
const getSnapshot = () => `${isAuthenticated() ? 1 : 0}|${getUserRole()}|${getUserName()}`;

export const useAuth = () => {
  const snapshot = useSyncExternalStore(subscribe, getSnapshot);
  const [authed, role, name] = snapshot.split('|');
  return {
    authenticated: authed === '1',
    role,
    name,
    isAdmin: role === 'admin',
  };
};

export default useAuth;
